<template>
	<div class="row justify-content-center">
		<div class="col-sm-10 col-sm-offset-1">
			<div class="panel panel-default p-l-15 p-r-15" style="background:#f0f0f0;">
				<div class="panel-body">
					<h5 class="info-text m-b-0-i">Add Individual Accident Cover</h5>
					<h6 class="category m-t-0 m-b-25">Benefit structure offer</h6>

					<ul>
						<li>Accident Only - Agreed Value $400 per week sum insured</li>
						<li>14 day waiting period</li>
						<li>52 week benefit period</li>
					</ul>

					<div class="form-group">
						<select
							class="form-control"
							v-model="selectedCover"
							:disabled="disabled"
							@change="addAccidentCover"
						>
							<option value="0">-- Select Accident Cover --</option>
							<option
								v-for="cover in covers"
								:key="cover.id"
								:value="cover.id"
							>
								{{ cover.description }}, ${{ cover.price }} per year
							</option>
						</select>
					</div>

					<div class="form-group">
						<input
							type="text"
							ref="insuredIndividual"
							class="form-control"
							placeholder="Name of Insured Individual"
							maxlength="190"
							v-model="insuredIndividual"
							:disabled="!selectedCover || disabled"
							@focus="$event.target.classList.add('form-control-highlighted')"
							@blur="$event.target.classList.remove('form-control-highlighted')"
						/>
					</div>

					<p class="category text-center font-10 p-b-20">
						Individual accident insurance cover is not bound until confirmed by the insurer
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import { getAccidentCovers } from '../configs'

export default {
	data() {
		return {
			selectedCover: 0,
			insuredIndividual: '',
			covers: []
		}
	},

	props: {
        disabled: {
            type: Boolean
		},
    },

	mounted () {
		this.dataLoad()
	},

	watch: {
		accidentCover (value) {
			if (value) {
				this.selectedCover = value.id
				this.insuredIndividual = value.insuredIndividual
			} else {
				this.selectedCover = 0
				this.insuredIndividual = ''
			}
		},

		insuredIndividual (value) {
			const cover = this.accidentCover

			if (cover) {
				cover.insuredIndividual = value
				this.updateAccidentCover({ cover })
			}

			this.$emit('changeName', value)
		}
	},

	computed: {
		...mapState({
			accidentCover: state => state.accidentCover
		}),
	},

	methods: {
		...mapMutations({
			updateAccidentCover: 'updateAccidentCover'
		}),

		dataLoad () {
			axios.get(getAccidentCovers).then(({
				data = []
			} = {}) => {
				this.covers = data
			}).catch(error => {
				if (error) {
					alert(error) // ???
				}
			})
		},

		addAccidentCover () {
			// Have to use a timeout in order to add blue highlight to the field
			// because otherwise it is not working cause of being disabled
			setTimeout(() => {
				this.$refs.insuredIndividual.focus()
			}, 100)

			const selectedCover = Number(this.selectedCover)
			const cover = selectedCover ?
				this.covers.filter(item => item.id === selectedCover)[0] :
				null

			if (cover) {
				cover.insuredIndividual = ''
			}

			this.updateAccidentCover({ cover })
			this.$emit('change', cover)
		},
	}
}
</script>

<style scoped>
.card {
	width: 375px;
}
h3.wizard-title {
	font-size: 24px;
}
.font-weight-normal {
	font-weight: normal;
}
.m-t-0 {
	margin-top: 0;
}
.wizard-header {
	height: 100%;
}
.font-10 {
	font-size: 10px;
}
.p-b-20 {
	padding-bottom: 20px;
}
.form-control-highlighted {
	border: 2px solid #30abe1;
}
</style>
